exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.math-buttons {\n\twidth: 100%;\n\tborder-collapse: collapse;\n}\n\n.math-buttons td, #pages-toolbar span {\n\ttext-align: center;\n\tborder: 1px solid rgba(0,0,0,0.1);\n\tmin-width: 32px;\n\t/* min-height: 32px; */\n\tcursor: pointer;\n\tdisplay: inline-block;\n\tmargin: 3px;\n\tline-height: 32px;\n\tbackground-color: aliceblue;\n}\n#pages-toolbar span.selected{\n\tbackground-color: #ffffff;\n}\n.math-buttons td:hover {\n\tbackground-color: #fff;\n}\n\n.math-buttons td .mathquill-rendered-math {\n\tcursor: pointer;\n\tvertical-align: middle;\n}\n\n.toolbar-button {\n\theight: 35px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tline-height: 35px;\n\tpadding: 0 8px;\n}\n#math-div {\n\tposition: absolute;\n\tbackground-color: aliceblue;\n\tpadding: 0 10px;\n\toverflow-y: scroll;\n\twidth: 100%;\n\tbox-sizing: border-box;\n\t\n\t\n}\n\n.wb-formula {\n\twidth: 100%;\n\tmin-height: 30px;\n\tfont-size: 30px;\n\tbackground-color: aliceblue;\n\tborder: none;\n\tborder-bottom: 1px solid grey;\n\tpadding: 0;\n}\n\n.math-tools, #pages-toolbar {\n\tposition: fixed;\n\ttop: 200px;\n\tleft: 200px;\n\tbackground-color: white;\n\tborder: 1px solid #8e8e93;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/wb/algebra/algebra.css
// module id = ../../../../../src/app/wb/algebra/algebra.css
// module chunks = main